import React, { useRef, useState, useEffect } from "react";
import { NavLink, Link, useHistory, Redirect } from "react-router-dom";
import { selectMenu } from ".././../actions/index";
import { useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import Logo from "../../assets/img/logo.png";
import userimg from "../../assets/img/userlogo.png";
import { BASE_PATH } from ".././../constants/Global";
import { WEB_URL } from ".././../constants/Global";
import AnchorLink from "react-anchor-link-smooth-scroll";
import Dropdown from "react-bootstrap/Dropdown";
import { deflautuserimage, dashboardicon, profile, logout } from "../../constants/Images";

const Header = (match) => {
  const user = JSON.parse(localStorage?.getItem("user")) ? JSON.parse(localStorage?.getItem("user"))[0] : "";

  useEffect(() => {
    JSON.parse(localStorage.getItem("user"));
  }, [user]);

  const history = useHistory({ forceRefresh: true });

  const dispatch = useDispatch();
  dispatch(selectMenu(match));
  const loginuser = useSelector((state) => state.setUserlog);
  const title = match.data.data?.data.title || "";

  // Check if navigation should be hidden
  const hideNavigation = match.hideNavigation || false;
  const hideMenu = match.hideMenu || false;
  const currentDomain = window.location.hostname;

  const hideLayoutDomains = [
    "auction.inboxwoods.com",
    "webstreaming.in",
  ];

  const hideLayout = hideLayoutDomains.includes(currentDomain);
  // const isTesting = true;
  // const hideLayout = isTesting
  //   ? true
  //   : currentDomain === "auction.inboxwoods.com";

  return (
    <>
      {/* Only show top bar if hideNavigation is false */}
      {!hideLayout && !hideNavigation && (
        <div className="top-bar-area address-one-lines bg-dark text-light">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-3">
                <div className="top-left">
                  <img
                    src={require("../../assets/img/Call-1.png")}
                    className=""
                    alt=""
                  />{" "}
                  + 91- 83860-11123
                </div>
              </div>

              <div className="text-right top-right col-md-9">
                <a
                  target="_blank"
                  href="https://www.youtube.com/watch?v=vCcppfCmlaQ&feature=youtu.be"
                >
                  HOW TO USE SOFTWARE ?
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      <header id="home">
        <nav
          id="header"
          className="navbar navbar-default navbar-sticky bootsnav"
        >
          <div className="container-fluid">
            {!hideLayout &&(<div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle"
                data-toggle="collapse"
                data-target="#navbar-menu"
              >
                <i className="fa fa-bars"></i>
              </button>
              <a href={WEB_URL}>
                <img src={Logo} className="logo" alt="Logo" />
              </a>
            </div>)}

            {loginuser == "" ? (
             
                <div className="menu-register-btn"> <Link to="/user-registration"> Register </Link>/<Link to="/"> Login </Link></div>
             
            ) : (
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  className="menu-register-btn menu-register-btn-after-login"
                >
                  {user?.cperson}{" "}
                  <img
                    src={loginuser['photo']?loginuser['photo'] : userimg}
                    style={{
                      width: "30px",
                      // height:"20px",
                      borderRadius: "50%",
                      paddingLeft: "4px",
                      paddingRight: "4px",
                    }}
                    // alt="Avatar"
                  />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item
                    onClick={(e) => history.push(BASE_PATH + "Dashboard")}
                    className={title == "Dashboard" ? "active-menu" : null}
                  >
                   <img src={dashboardicon} alt="" /> {" "} Dashboard
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => history.push(BASE_PATH + "my-profile")}
                    className={title == "My Profile" ? "active-menu" : null}
                  >
                    <img src={profile} alt="" /> {" "} Profile
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={(e) => history.push(BASE_PATH + "Logout")}
                  >
                   <img src={logout} alt="" /> {" "} Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}

            {/* Only show navigation tabs if hideNavigation is false */}
            {!hideLayout && !hideNavigation && (
              <div className="collapse navbar-collapse" id="navbar-menu">
                {window.location.pathname == "/" ? (
                  <ul
                    className="nav navbar-nav navbar-right"
                    data-in="#"
                    data-out="#"
                  >
                    <li>
                      <AnchorLink href={WEB_URL+"today-auction"}>
                        Today Auctions
                      </AnchorLink>
                    </li>

                    <li>
                      <AnchorLink href={WEB_URL+"upcoming-auction"}>
                        Upcoming Auctions
                      </AnchorLink>
                    </li>

                    <li>
                      <AnchorLink href={WEB_URL+"#our-clients"}>Clients</AnchorLink>
                    </li>

                    <li>
                      <AnchorLink href={WEB_URL+"pricing"}>Pricing</AnchorLink>
                    </li>

                    <li>
                      <AnchorLink href={WEB_URL+"#contact-us"}>Contact Us</AnchorLink>
                    </li>
                  </ul>
                ) : (
                  <ul
                    className="nav navbar-nav navbar-right"
                    data-in="#"
                    data-out="#"
                  >
                    <li>
                      <a href={WEB_URL+"today-auction"}>Today Auctions</a>
                    </li>

                    <li>
                      <a href={WEB_URL+"upcoming-auction"}>Upcoming Auctions</a>
                    </li>

                    <li>
                      <a href={WEB_URL+"#our-clients"}>Clients</a>
                    </li>

                    <li>
                      <a href={WEB_URL+"pricing"}>Pricing</a>
                    </li>

                    <li>
                      <a href={WEB_URL+"#contact-us"}>Contact Us</a>
                    </li>
                  </ul>
                )}
              </div>
            )}
          </div>
        </nav>
      </header>
    </>
  );
};

export default Header;
